/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entityoffersdescription2Inputs */

const id_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri toko`)
};

const ms_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri kedai`)
};

const da_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiksposter`)
};

const de_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store-Einträge`)
};

const en_us2_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store entries`)
};

const es_es2_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de tienda`)
};

const es_mx2_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de tienda`)
};

const fil_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga entry sa tindahan`)
};

const fr_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrées de la vitrine`)
};

const it_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci del negozio`)
};

const hu_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolt bejegyzések`)
};

const nl_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winkelvermeldingen`)
};

const no_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikkoppføringer`)
};

const pl_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisy sklepowe`)
};

const pt_br2_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas da loja`)
};

const pt_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos da loja`)
};

const ro_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înregistrări din magazin`)
};

const fi_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauppapaikan merkinnät`)
};

const sv_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiksposter`)
};

const vi_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục cửa hàng`)
};

const tr_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza girişleri`)
};

const cs_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky obchodu`)
};

const bg_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазинни записи`)
};

const ru_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи витрины`)
};

const uk_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи магазину`)
};

const ar_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات المتجر`)
};

const hi_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोर प्रविष्टियाँ`)
};

const th_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการในร้านค้า`)
};

const ja_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアエントリー`)
};

const zh_cn2_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店条目`)
};

const zh_hant1_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店條目`)
};

const ko_sandboxes_entityoffersdescription2 = /** @type {(inputs: Sandboxes_Entityoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어 항목`)
};

/**
* | output |
* | --- |
* | "Store entries" |
*
* @param {Sandboxes_Entityoffersdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entityoffersdescription2 = /** @type {((inputs?: Sandboxes_Entityoffersdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entityoffersdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entityoffersdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_entityoffersdescription2(inputs)
	if (locale === "da") return da_sandboxes_entityoffersdescription2(inputs)
	if (locale === "de") return de_sandboxes_entityoffersdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entityoffersdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entityoffersdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entityoffersdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_entityoffersdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_entityoffersdescription2(inputs)
	if (locale === "it") return it_sandboxes_entityoffersdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_entityoffersdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_entityoffersdescription2(inputs)
	if (locale === "no") return no_sandboxes_entityoffersdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_entityoffersdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entityoffersdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_entityoffersdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_entityoffersdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_entityoffersdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_entityoffersdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_entityoffersdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_entityoffersdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_entityoffersdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_entityoffersdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_entityoffersdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_entityoffersdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_entityoffersdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_entityoffersdescription2(inputs)
	if (locale === "th") return th_sandboxes_entityoffersdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_entityoffersdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entityoffersdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entityoffersdescription2(inputs)
	return ko_sandboxes_entityoffersdescription2(inputs)
});
export { sandboxes_entityoffersdescription2 as "sandboxes.entityOffersDescription" }